import * as Sentry from '@sentry/browser';
/* eslint-disable camelcase */
import { BalanceManagerApiService } from '@/services/api';

export type PaymentType = {
  id: string;
  contract_id: string;
  delay_fee: string;
  delay_interest: string;
  created_at: string;
  payment_date: string;
  paid_value: string;
  receivable_id: string;
  inserted_at: string;
  updated_at: string;
};

type usePaymentType = {
  getPayments: (contractId: string) => Promise<PaymentType[]>;
};

function usePayment(): usePaymentType {
  const { api } = BalanceManagerApiService();

  async function getPayments(contractId: string): Promise<PaymentType[]> {
    try {
      const { data } = await api.get<PaymentType[]>(
        `/external/v1/contract/${contractId}/payments`,
      );

      return data;
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          message: `Attempt to retrieve payments ended in failure, possibly due to the absence of the contract's id`,
        },
      });
    }

    return [];
  }

  return { getPayments };
}

export default usePayment;
